/**
 * API Configuration
 */

export const API_BASE_URL = process.env.REACT_APP_API_URL || '';

/**
 * API Versions Configuration
 * Add new versions here as they become available
 */
export const API_VERSIONS = {
  V1: 1,
  // V2: 2, // Uncomment when V2 is ready
  // V3: 3, // Uncomment when V3 is ready
};

/**
 * Current active API version
 * Change this to switch to a different version globally
 */
export const CURRENT_API_VERSION = API_VERSIONS.V1;

/**
 * Build a versioned API endpoint
 * @param {number} version - API version number
 * @param {string} path - Endpoint path (should start with /)
 * @returns {string} Full API URL
 */
export function buildApiUrl(path, version = CURRENT_API_VERSION) {
  return `${API_BASE_URL}/api/v${version}${path}`;
}
